import { Typography } from '@mui/material';
import styled from 'styled-components';

const PageContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const ContentContainer = styled.div`
  max-width: ${({ theme }) => theme.breakpoints.values.md}px;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  width: 100%;
`;

const LessonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
`;

const DayText = styled(Typography)`
`;

const Header = styled.div`
  position: sticky;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  top: 0;
  background-color: ${({ theme }) => theme.palette.background.paper};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  padding: ${({ theme }) => theme.spacing(1)};
  z-index: ${({ theme }) => theme.zIndex.appBar};
`;

const DefaultContentContainer = styled.div`
`;

const AlertContainer = styled.div`
  cursor: pointer;
`;

const DividerContainer = styled.div`
  width: 100%;
`;

const TimeDividerLabel = styled.div`
  white-space: nowrap;
`;

const RollLessonsToggleBar = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-bottom: ${({ theme }) => theme.spacing(1)};
`;

interface RollLessonsToggleProps {
  $selected: boolean;
  $color: 'primary' | 'error' | 'success'
}

const RollLessonsToggle = styled(Typography)<RollLessonsToggleProps>`
&& {
  &:hover {
    background-color: ${({ theme }) => theme.palette.backdrop.main};
    color: ${({ theme, $color }) => theme.palette[$color].dark};
  }
  border-radius: ${({ theme }) => theme.shape.borderRadius * 3}px;
  padding: ${({ theme }) => theme.spacing(0.5, 1.5)};
  color: ${({ $selected, theme, $color }) => ($selected ? theme.palette[$color].dark : theme.palette.gray.main)};
  font-weight: ${({ $selected }) => ($selected ? 600 : 'none')};
  border-color: ${({ theme, $color }) => theme.palette[$color].dark};
  background-color: ${({ theme, $selected }) => ($selected ? theme.palette.backdrop.main : 'inherit')};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  }
`;

const ToggleHeading = styled(Typography)`
  width: 80px; 
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export { ContentContainer,
  TimeDividerLabel,
  PageContainer,
  AlertContainer,
  DayText,
  DividerContainer,
  Header,
  LessonsContainer,
  DefaultContentContainer,
  RollLessonsToggleBar,
  RollLessonsToggle,
  ToggleHeading };
